import { gql } from '@/lib/graphql/gql'

export const RECENT_SERVICES_DISPLAY_COUNT = 6

export const RECENT_SERVICES_QUERY = gql`
  query RecentServices(
    $idCompany: String!
    $serviceOrderBy: JSON
    $limit: Int!
  ) {
    company(id: $idCompany) {
      id
      apps(offset: 0, limit: $limit, orderBy: $serviceOrderBy) @live {
        id
        total
        items {
          id
          name
          displayName
          source
          dockerImage
          status
          updatedAt
          isSuspended
          lastDeployment {
            id
            updatedAt
            commitSha
            commitMessage
          }
        }
      }
      databases(offset: 0, limit: $limit, orderBy: $serviceOrderBy) @live {
        id
        total
        items {
          id
          name
          displayName
          status
          storageSize
          type
          updatedAt
          isSuspended
        }
      }
      objectStorages(offset: 0, limit: $limit, orderBy: $serviceOrderBy) @live {
        id
        total
        items {
          id
          name
          displayName
          updatedAt
        }
      }
      edgeLoadBalancers(offset: 0, limit: $limit, orderBy: $serviceOrderBy)
        @live {
        id
        total
        items {
          id
          name
          displayName
          updatedAt
        }
      }
      staticSites(offset: 0, limit: $limit, orderBy: $serviceOrderBy) @live {
        id
        total
        items {
          id
          name
          displayName
          status
          updatedAt
          deployments: staticSiteDeployments(limit: 1) {
            id
            items {
              id
              commitMessage
              commitSha
              updatedAt
            }
          }
        }
      }
    }
  }
`
